/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Tags_Manager_Error_Get_Sets_ToastInputs */



/**
* | output |
* | --- |
* | "Error getting tag sets: {error}" |
*
* @param {Tags_Manager_Error_Get_Sets_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_error_get_sets_toast = /** @type {((inputs: Tags_Manager_Error_Get_Sets_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Error_Get_Sets_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Erreur lors de la recuperation des ensembles de tags : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Fehler beim Abrufen der Tag-Sets: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Errore durante il recupero dei set di tag: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Ошибка при получении наборов тегов: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error al obtener conjuntos de etiquetas: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`获取标签集时出错：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`タグセットの取得中にエラーが発生しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`टैग सेट प्राप्त करने में त्रुटि: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Erro ao obter conjuntos de tags: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Error getting tag sets: ${i?.error}`)
});